import React from 'react';
import { Icon } from 'shared/components/ui/icon';

const SIZE = 16;
const STROKE_WIDTH = 1.5;

export type FormFieldIconProps = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

// The leading glyph on a form row: one size and weight across every form.
export const FormFieldIcon: React.FC<FormFieldIconProps> = ({ icon }) => (
  <Icon icon={icon} size={SIZE} strokeWidth={STROKE_WIDTH} />
);
